import styled from 'styled-components';
import {TextInputComponent} from '../../molecules/TextInput';
import InputChip from '../../molecules/InputChip';
import Checkbox from '../../atoms/Checkbox';
import {DividerColor,Grey500,ColorDefs} from '../../Colors';


export default {
	Wrapper : styled.div`
        font-size:1.5rem;
        border-bottom : 1px dotted ${DividerColor};
    `,
	QuizHeader : styled.div`
        display : flex;
        `,
	Title : styled.div`
        padding : 10px 10px 15px 10px;
        border-left : 1px dotted ${DividerColor};
    `,
	Shuffle : styled.div`
        padding : 10px 10px 15px 10px;
    `,
	Checkbox : styled(Checkbox).attrs({
		color : ColorDefs.default
	})`
        vertical-align : top;
    `,
	TagsWrapper : styled.div`
        width : 100%;
        white-space : nowrap;
        overflow: auto;
        border-bottom : 1px solid ${DividerColor};
        padding-bottom : 0.5rem;
    `,
	TagLabel : styled.span`
        display : inline-block;
        vertical-align : top;
        padding : 2px;
        font-size : 0.8rem;
        color : ${Grey500};
    `,
	Tags : styled.div`
        width : 70%;
        display : inline-block;
        vertical-align : middle;
    `,
	InputChip : styled(InputChip)`
        margin-left : 1rem;
        margin-top : 1rem;
        font-size : 1.5rem;
    `,
	TextInput : styled(TextInputComponent)`
        border : none;
        padding : 0;
        width : 90%;
        border-radius : 0;
        border-bottom : 1px solid ${DividerColor};
        margin-bottom : 2px;
    `
};